<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-合作机构">
    <img src="http://123.56.170.62:9999/static/bg/banner3.png" alt />
    <div class="content">
      <AllHeader title="合作机构"></AllHeader>
      <div class="tswrapper">
        <div class="tscontent">
          <div
            class="tsbox"
            :style="(index + 1) % 5 != 0 ? '' : 'margin-right:0'"
            v-for="(item, index) in comData"
            :key="item.name"
          >
            <a
              :href="'http://' + item.link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img :src="item.path" :title="item.name" alt />
            </a>
          </div>
        </div>
        <div class="tspage" v-if="paginations.total > paginations.page_size">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="paginations.page_index"
            :page-size="paginations.page_size"
            :total="paginations.total"
            layout="prev, pager, next"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue"
import { getCom } from "@/api/home.js"
import Bus from "@/utils/bus.js"
import { BASE_URL } from "@/utils/base.js"
export default {
  data() {
    return {
      comData: [],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 15, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.getData()
  },
  methods: {
    async getData() {
      let coms = new FormData()
      coms.append("page", this.paginations.page_index)
      coms.append("rows", this.paginations.page_size)
      let com = await getCom(coms)
      this.paginations.total = com.total
      this.comData = com.rows
      this.comData.map((item) => {
        return (item.path = BASE_URL + item.path)
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val
      this.getData()
    },
  },
  components: {
    AllHeader,
  },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  img {
    width: 100%;
    height: 400px;
  }
  .content {
    padding-top: 20px;
    width: 810px;
    margin: 0px auto;
    .tswrapper {
      margin: 40px auto;
      .tscontent {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .tsbox {
          width: 140px;
          height: 140px;
          border: solid 1px #ccc;
          margin-right: 24px;
          margin-bottom: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          a {
            img {
              width: 84px;
              height: 84px;
              line-height: 140px;
              text-align: center;
            }
          }
        }
      }
      .tspage {
        margin: 70px 0 90px;
        text-align: center;
        /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #fd7a3a;
          border: none;
        }
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
          background-color: #fff; // 进行修改未选中背景和字体
          border: 1px solid #ededed;
          // color: #fff;
        }
        /deep/ .el-pagination.is-background button {
          background-color: #fff; // 进行修改未选中背景和字体
          border: 1px solid #ededed;
          // color: #fff;
        }
      }
    }
  }
}
</style>
